
import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import {
  DesignContext,
  DragInfo,
  LayoutConfig,
  Part,
  Units,
  WebpartMoveLayerOptions,
} from '../types'
import PartDesignControl from './PartDesignControl.vue'
import IconButton from "./IconButton.vue";

type PartContainerStyle = {
  top: string
  left: string
  width: string
  height: string
}

/**
 * 웹파트를 담는 컨테이너 컴포넌트
 */
@Component({
  name: 'part-container',
  components: {PartDesignControl, IconButton},
})
export default class PartContainer extends Vue {
  @Prop({type: Object}) layout!: LayoutConfig
  @Prop({type: Object}) part!: Part
  @Prop({type: Object}) units!: Units
  @Prop({type: Boolean, default: true}) preview!: boolean
  @Prop({type: Object}) context!: DesignContext

  get style(): PartContainerStyle {
    return {
      top: this.part.rowidx * this.units.height + 'px',
      left: this.part.colidx * this.units.width + 'px',
      width: this.part.colcnt * this.units.width + 'px',
      height: this.part.rowcnt * this.units.height + 'px',
    }
  }

  get lock(): boolean {
    return this.part.lock
  }

  get editable(): boolean {
    const {lock} = this.part
    const {personal} = this.layout

    // 개인화 환경이면서 Lock이 걸린 상태인 경우, 개인화 금지 영역이기 때문에 수정 제한
    if (personal && lock) return false
    return true
  }

  mousedown(name: 'drag' | 'resize', e: MouseEvent) {
    this.context.selected = this.part.webpartId
    // 잠겨있을 경우 Drag & Drop을 이용하여 이동 불가
    if (this.lock) return
    //@ts-ignore
    let outer = document.defaultView.getComputedStyle(this.$el)
    //@ts-ignore
    let inner = document.defaultView.getComputedStyle(this.$refs.content)

    const options: DragInfo = {
      part: this.part,
      //@ts-ignore
      event: e,
      initialPos: {
        left: parseFloat(outer.getPropertyValue('left')),
        top: parseFloat(outer.getPropertyValue('top')),
        width: parseFloat(outer.getPropertyValue('width')),
        height: parseFloat(outer.getPropertyValue('height')),
      },
      //  initialPos: {
      //     left:
      //         parseFloat(outer.getPropertyValue('left')) +
      //         parseFloat(outer.getPropertyValue('padding-left')) +
      //         parseFloat(outer.getPropertyValue('border-left-width')),
      //     top:
      //         parseFloat(outer.getPropertyValue('top')) +
      //         parseFloat(outer.getPropertyValue('padding-top')) +
      //         parseFloat(outer.getPropertyValue('border-top-width')),
      //     width: parseFloat(inner.getPropertyValue('width')),
      //     height: parseFloat(inner.getPropertyValue('height')),
      // },
    }
    this.$emit(name, options)
  }

  toggleLock() {
    this.part.lock = !this.part.lock
  }

  handleControlAction(action: string) {
    switch (action) {
      case 'lock':
        this.toggleLock()
        break
      case 'front':
      case 'forward':
      case 'back':
      case 'backward':
        const options: WebpartMoveLayerOptions = {
          action: action,
          part: this.part,
        }
        this.$emit('move-layer', options)
        break
      case 'delete':
        this.part.available = true
        break
    }
  }
}
